import firebase from 'firebase/app';

export const handleChangeToTeam = async(profile, auth) =>{
    await  firebase
             .firestore()
             .collection('organizations')
             .doc(profile.company)
             .collection('teamToken')
             .doc(profile.company)
             .get()
             .then(
             function(doc)
             {
                 if(doc.exists){
                     //console.log("document exists")
                     firebase
                     .firestore()
                     .collection('organizations')
                     .doc(profile.company)
                     .collection('teamToken')
                     .doc(profile.company)
                     .update({
                         teamToken: true,
                     })
                 } else{
                     //console.log("document doesnt exists")
                     firebase
                     .firestore()
                     .collection('organizations')
                     .doc(profile.company)
                     .collection('teamToken')
                     .doc(profile.company)
                     .set({
                         firstName: profile.firstName,
                         lastName: profile.lastName,
                         company: profile.company,
                         email: profile.email,
                         adminId: auth.uid,
                         teamToken: true,
                     })
                 }
             }
     )  
}   

export const handleChangeToPersonal = async(profile, auth) =>{
    await  firebase
             .firestore()
             .collection('organizations')
             .doc(profile.company)
             .collection('teamToken')
             .doc(profile.company)
             .get()
             .then(
             function(doc)
             {
                 if(doc.exists){
                     //console.log("document exists")
                     firebase
                     .firestore()
                     .collection('organizations')
                     .doc(profile.company)
                     .collection('teamToken')
                     .doc(profile.company)
                     .update({
                         teamToken: false,
                     })
                 } else{
                     //console.log("document doesnt exists")
                     firebase
                     .firestore()
                     .collection('organizations')
                     .doc(profile.company)
                     .collection('teamToken')
                     .doc(profile.company)
                     .set({
                         firstName: profile.firstName,
                         lastName: profile.lastName,
                         company: profile.company,
                         email: profile.email,
                         adminId: auth.uid,
                         teamToken: false,
                         
                     })
                 }
             }
     )  
}   